import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useContext } from 'react';
import { useClients } from '../clients';
import { useABTest } from '../../extensible/ab-test-context';
export var FILTERS_EXPERIMENT_ID = 'filters-experiment';
export var NO_MORE_FASTER_SEARCH_EXPERIMENT_ID = 'peach';
export var DefaultFeatures = Object.freeze({
  isMultiSite: false
});
var ConfluenceFeatureContext = /*#__PURE__*/React.createContext(DefaultFeatures);
export var ConfluenceFeaturesProvider = function ConfluenceFeaturesProvider(_ref) {
  var children = _ref.children,
    featuresOverride = _ref.features;
  var _useClients = useClients(),
    _useClients$sites = _useClients.sites,
    sites = _useClients$sites === void 0 ? [] : _useClients$sites;
  var abTest = useABTest();
  var value = _objectSpread(_objectSpread(_objectSpread({}, DefaultFeatures), {
    isMultiSite: sites.length > 1,
    isFasterSearchDisabled: (abTest === null || abTest === void 0 ? void 0 : abTest.experimentId) === NO_MORE_FASTER_SEARCH_EXPERIMENT_ID
  }), featuresOverride);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  var memoedValue = React.useMemo(function () {
    return value;
  }, _toConsumableArray(Object.values(value)));
  return /*#__PURE__*/React.createElement(ConfluenceFeatureContext.Provider, {
    value: memoedValue
  }, children);
};
export var useFeatures = function useFeatures() {
  return useContext(ConfluenceFeatureContext);
};